import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon, SendIcon } from 'lucide-react';
export function ContactUs() {
  return <main className="bg-[#F8F9FA] min-h-screen" data-id="element-126">
      <section className="py-20 bg-[#588157] text-white" data-id="element-127">
        <div className="container mx-auto px-4 text-center" data-id="element-128">
          <h1 className="text-5xl font-serif mb-6" data-id="element-129">Contact Us</h1>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-130">
            We are here to support your journey toward restoration and wellness.
            Reach out to us today to schedule a consultation.
          </p>
        </div>
      </section>

      <section className="py-20" data-id="element-131">
        <div className="container mx-auto px-4" data-id="element-132">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-133">
            <div data-id="element-134">
              <h2 className="text-3xl font-serif text-[#588157] mb-8" data-id="element-135">
                Get in Touch
              </h2>
              <div className="space-y-8" data-id="element-136">
                <div className="flex items-start gap-6" data-id="element-137">
                  <div className="w-12 h-12 bg-[#588157]/10 rounded-xl flex items-center justify-center text-[#588157] flex-shrink-0" data-id="element-138">
                    <MailIcon size={24} data-id="element-139" />
                  </div>
                  <div data-id="element-140">
                    <h4 className="font-bold text-[#588157] mb-1" data-id="element-141">Email Us</h4>
                    <p className="text-[#4a6d49]/70" data-id="element-142">
                      info@globalrestorative.com
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-143">
                  <div className="w-12 h-12 bg-[#588157]/10 rounded-xl flex items-center justify-center text-[#588157] flex-shrink-0" data-id="element-144">
                    <PhoneIcon size={24} data-id="element-145" />
                  </div>
                  <div data-id="element-146">
                    <h4 className="font-bold text-[#588157] mb-1" data-id="element-147">Call Us</h4>
                    <p className="text-[#1A374D]/70 font-medium" data-id="element-148">
                      +1 (443) 949-981
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-149">
                  <div className="w-12 h-12 bg-[#588157]/10 rounded-xl flex items-center justify-center text-[#588157] flex-shrink-0" data-id="element-150">
                    <MapPinIcon size={24} data-id="element-151" />
                  </div>
                  <div data-id="element-152">
                    <h4 className="font-bold text-[#588157] mb-1" data-id="element-153">Visit Us</h4>
                    <p className="text-[#1A374D]/70 font-medium" data-id="element-154">
                      15627 Elsmere Ct,
                      <br data-id="element-155" />
                      Bowie, MD 20716
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-6" data-id="element-156">
                  <div className="w-12 h-12 bg-[#588157]/10 rounded-xl flex items-center justify-center text-[#588157] flex-shrink-0" data-id="element-157">
                    <ClockIcon size={24} data-id="element-158" />
                  </div>
                  <div data-id="element-159">
                    <h4 className="font-bold text-[#588157] mb-1" data-id="element-160">Hours</h4>
                    <p className="text-[#4a6d49]/70" data-id="element-161">
                      Monday - Friday: 9am - 5pm
                      <br data-id="element-162" />
                      Saturday: By Appointment
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-10 rounded-3xl shadow-sm border border-[#588157]/5" data-id="element-163">
              <h3 className="text-2xl font-serif text-[#588157] mb-8" data-id="element-164">
                Send a Message
              </h3>
              <form className="space-y-6" data-id="element-165">
                <div className="grid md:grid-cols-2 gap-6" data-id="element-166">
                  <div className="space-y-2" data-id="element-167">
                    <label className="text-sm font-bold text-[#588157] uppercase tracking-wider" data-id="element-168">
                      Full Name
                    </label>
                    <input type="text" className="w-full px-4 py-3 rounded-xl border border-[#588157]/10 focus:outline-none focus:ring-2 focus:ring-[#588157]/20" placeholder="John Doe" data-id="element-169" />
                  </div>
                  <div className="space-y-2" data-id="element-170">
                    <label className="text-sm font-bold text-[#588157] uppercase tracking-wider" data-id="element-171">
                      Email Address
                    </label>
                    <input type="email" className="w-full px-4 py-3 rounded-xl border border-[#588157]/10 focus:outline-none focus:ring-2 focus:ring-[#588157]/20" placeholder="john@example.com" data-id="element-172" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-173">
                  <label className="text-sm font-bold text-[#588157] uppercase tracking-wider" data-id="element-174">
                    Subject
                  </label>
                  <select className="w-full px-4 py-3 rounded-xl border border-[#588157]/10 focus:outline-none focus:ring-2 focus:ring-[#588157]/20" data-id="element-175">
                    <option data-id="element-176">Medical Services Inquiry</option>
                    <option data-id="element-177">Mental Wellness Coaching</option>
                    <option data-id="element-178">SYMBIS Marriage Coaching</option>
                    <option data-id="element-179">General Inquiry</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-180">
                  <label className="text-sm font-bold text-[#588157] uppercase tracking-wider" data-id="element-181">
                    Message
                  </label>
                  <textarea rows={4} className="w-full px-4 py-3 rounded-xl border border-[#588157]/10 focus:outline-none focus:ring-2 focus:ring-[#588157]/20" placeholder="How can we help you?" data-id="element-182"></textarea>
                </div>
                <button className="w-full py-4 bg-[#588157] text-white font-bold rounded-xl hover:bg-[#4a6d49] transition-all flex items-center justify-center gap-2" data-id="element-183">
                  <SendIcon size={20} data-id="element-184" />
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>;
}